import { isVisible } from './utils';

const moduleName = 'menu';

export const openMenu = (btn, menu, main) => {
    if(btn && menu) {
        btn.classList.add('_active');
        if(!main) {
            menu.classList.remove('_hidden');
            menu.classList.add('_visible');
        }else {
            menu.classList.add('_opened');
            document.body.classList.add('has-menu');
            const overlay = document.createElement('div');
            overlay.classList.add('overlay');
            document.body.classList.add('has-overlay');
            document.querySelector('.page').appendChild(overlay);
            overlay.classList.add('_visible');
            overlay.addEventListener('click', (e) => {
                const target = e.target;
                if (menu !== target && !menu.contains(target)) {
                    closeMenu(btn, menu, true);
                }
            }, false);
        }
    }
}

export const closeMenu = (btn, menu, main) => {
    if(btn && menu) {
        btn.classList.remove('_active');
        if(!main) {
            menu.classList.add('_hidden');
            setTimeout(function () {
                menu.classList.remove('_visible');
                menu.classList.remove('_hidden');
                if (main) document.body.classList.remove('has-menu');
            }, 300);

        }else {
            menu.classList.remove('_opened');
            const overlay = document.querySelector('.overlay');
            overlay.classList.add('_hidden');
            overlay.classList.remove('_visible');
            setTimeout(function () {
                overlay.parentNode.removeChild(overlay);
            }, 300);
            document.body.classList.remove('has-overlay');
        }
    }
}

export function menu () {
    const menu = document.querySelector('.js-main-menu');
    const openMenuBtn = document.querySelector('.js-open-main-menu');
    const parentItems = document.querySelectorAll('.js-parent');



    if (menu && openMenuBtn) {
        openMenuBtn.addEventListener('click', function () {
            if (menu.classList.contains('_opened')) {
                closeMenu(openMenuBtn, menu, true);
            } else {
                openMenu(openMenuBtn, menu, true);
            }
        });
    }

    if (parentItems.length) {
        Array.from(parentItems).forEach((item) => {
            const dropdown = item.querySelector('.js-dropdown');
            item.addEventListener('mouseenter', function () {
                if (dropdown) {
                    openMenu(item, dropdown, false);
                }
            });
            item.addEventListener('mouseleave', function () {
                if (dropdown) {
                    closeMenu(item, dropdown, false);
                }
            });
        });
    }
}
